<template>
  <div class="flex size-full min-h-[400px] flex-col items-center justify-center">
    <font-awesome-icon v-if="!ctxLoading" :icon="faSpinnerThird" spin size="2x" class="text-gp-mouse/60" />
  </div>
</template>

<script setup lang="ts">
import { faSpinnerThird } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { computed } from "vue";
import { useServiceStore } from "../../store/service";

const service = useServiceStore();

const ctxLoading = computed(() => service.isLoading);
</script>
